// src/components/Footer.js — Branded footer copy
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { APP_NAME, APP_TITLE } from '../config/branding';
import { getSelectedBranchId, getStoredAdmin } from '../config/api';
import { toBranchDisplayName } from '../config/branchNames';

const Footer = () => {
  const theme = useTheme();
  const admin = getStoredAdmin();
  const selectedBranchId = Number(getSelectedBranchId() || admin?.active_branch_id || 0);
  const allowedBranches = Array.isArray(admin?.allowed_branches) ? admin.allowed_branches : [];
  const selectedBranch = allowedBranches.find((b) => Number(b?.id) === selectedBranchId);
  const branchName = toBranchDisplayName({
    branchId: selectedBranch?.id || selectedBranchId,
    branchName: selectedBranch?.name || process.env.REACT_APP_BRANCH_NAME || '',
    branchCode: selectedBranch?.code || process.env.REACT_APP_BRANCH_CODE || '',
  });
  const title = `${APP_NAME} ${branchName}`.trim() || APP_TITLE;

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        textAlign: 'center',
        color: '#fff',
        backgroundColor: theme.palette?.secondary?.main || '#e1ac2a',
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        © {new Date().getFullYear()} · {title} · Developed by Lemda (Pvt) Ltd
      </Typography>
    </Box>
  );
};

export default Footer;
